module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('figure', {
    staticClass: "figure"
  }, [_c('p', {
    staticClass: "fig"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "408",
      "src": "images/Chi-rapp-fig01001.jpeg",
      "width": "600"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "figh"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pxiv"
    }
  }), _vm._v("Mike “King” Kelly, baseball’s first matinee idol, inspired the cheer “Slide, Kelly, Slide,” which became the title of a Tin Pan Alley ditty and a painting hung in many barrooms. (Courtesy of the McGreevey Collection, Boston Public Library.)")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0323eb84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-rapp-0010.vue
// module id = 81
// module chunks = 0